import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import * as THREE from 'three';

export default function CosmicFog() {
  const { scene } = useThree();

  useEffect(() => {
    const isLight = document.documentElement.getAttribute('data-theme') === 'light';
    if (isLight) {
      scene.fog = new THREE.FogExp2('#f6fafd', 0.002);
    } else {
      // Ultra-subtle deep space atmospheric haze (doesn't black out the supernova)
      scene.fog = new THREE.FogExp2('#07090e', 0.0006);
    }

    return () => {
      scene.fog = null;
    };
  }, [scene]);

  return null;
}
